import {DateRangeValueProps} from 'features/GlobalFilterProvider/filters/period/DateRangeItem/types';

import {formatDateToString, dayjs, todayString} from 'utils/dateUtils';

import Switch from 'components/form-next/Switch';

import {FromToDatePicker} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/DateRangeBlock/FromToDatePicker';

export const AdditionalPeriodGroup = ({value, updateValue}: DateRangeValueProps) => {
  return (
    <>
      <Switch
        data-testid='additional-periods-switch'
        checked={!!value.additionalPeriod}
        label='Additional filter by transaction date'
        slotProps={{
          typography: {
            variant: 'body3',
          },
        }}
        onChange={(e, period) => {
          updateValue({
            additionalPeriod: period
              ? {
                  from: value.from || formatDateToString(dayjs().subtract(1, 'year')),
                  to: value.to || formatDateToString(),
                }
              : undefined,
          });
        }}
      />

      {value.additionalPeriod && (
        <FromToDatePicker
          dataTestId='additional-period-date-picker'
          from={value.additionalPeriod.from}
          to={value.additionalPeriod.to}
          maxDate={todayString}
          onChange={(from, to) =>
            updateValue({
              additionalPeriod: {
                from: from ?? undefined,
                to: to ?? undefined,
              },
            })
          }
        />
      )}
    </>
  );
};
